export const taxProfile = {
  taxProfileNavTitle: 'Datos fiscales',
  taxProfileRowAction: 'Agregar o editar datos fiscales',
  taxProfileOrganizationTitle: 'Datos fiscales del negocio',
  taxProfileOrganizationSubtitle:
    'Así aparecerá tu negocio como emisor en cada factura electrónica.',
  taxProfileContactTitle: 'Datos fiscales',
  taxProfileContactSubtitle:
    'Necesarios para emitir un Crédito Fiscal a este cliente.',
  taxProfileContactCreateHint:
    'Después de guardar el contacto podrás agregar sus datos fiscales desde Editar.',
  taxProfileNotAvailable:
    'Los datos fiscales solo están disponibles para organizaciones de El Salvador.',
  taxProfileIdentitySection: 'Identificación',
  taxProfileNamesSection: 'Nombre y actividad',
  taxProfileAddressSection: 'Dirección',
  taxProfileTaxpayerType: 'Tipo de contribuyente',
  taxProfileDui: 'DUI',
  taxProfileNit: 'NIT',
  taxProfileNrc: 'NRC',
  taxProfileNitOrDui: 'DUI o NIT',
  taxProfileIdentityHelp:
    'Basta con uno de los dos: DUI o NIT. Puedes escribirlos con guiones; se guardan solo los números, como los pide Hacienda.',
  taxProfileOtherDocumentType: 'Otro documento (extranjeros)',
  taxProfileOtherDocumentNumber: 'Número de documento',
  taxProfileLegalName: 'Razón social o nombre',
  taxProfileTradeName: 'Nombre comercial',
  taxProfileEconomicActivity: 'Actividad económica',
  taxProfileEconomicActivitySearch: 'Busca por código o descripción',
  taxProfileDepartment: 'Departamento',
  taxProfileMunicipality: 'Municipio',
  taxProfileDistrict: 'Distrito',
  taxProfileAddress: 'Dirección (colonia, calle y número)',
  taxProfilePhone: 'Teléfono',
  taxProfileEmail: 'Correo para facturas',
  taxProfileSelect: 'Selecciona una opción',
  taxProfileReadyOrganization:
    'Tu negocio tiene todos los datos fiscales para emitir facturas electrónicas.',
  taxProfileReadyContact:
    'Listo para Crédito Fiscal: este cliente tiene todos los datos que se necesitan.',
  taxProfileIncompleteOrganization:
    'Faltan datos para emitir facturas electrónicas',
  taxProfileIncompleteContact: 'Faltan datos para emitir un Crédito Fiscal',
  taxProfileMissingFields: 'Completa:',
  taxProfileInvalidDui: 'El DUI debe tener 9 dígitos',
  taxProfileInvalidNit: 'El NIT debe tener 14 dígitos',
  taxProfileInvalidNrc: 'El NRC debe tener entre 2 y 8 dígitos',
  taxProfileInvalidDocumentNumber: 'Debe tener entre 6 y 20 letras o números',
  taxProfileInvalidPhone:
    'El teléfono debe tener al menos 8 dígitos y solo números, espacios, guiones o paréntesis',
  taxProfileInvalidEmail:
    'El correo debe tener un @ y un dominio con extensión, por ejemplo facturas@negocio.com',
  taxProfileSave: 'Guardar datos fiscales',
  taxProfileSaved: 'Datos fiscales guardados',
  taxProfileSaveError: 'No se pudieron guardar los datos fiscales',
  taxProfileLoadError:
    'No se pudieron cargar los datos fiscales. Intenta de nuevo.',
};
